import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    height: '100%',
  },
  statCard: {
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
  },
  statLabel: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
  },
  statValue: {
    fontSize: 15,
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  clickRateRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    marginBottom: theme.spacing(0.5),
  },
  clickRate: {
    fontSize: 32,
    fontWeight: 700,
    color: theme.palette.text.primary,
    lineHeight: 1.1,
  },
  averageChip: {
    backgroundColor: theme.palette.phishing.difficulty.hard.background,
    color: theme.palette.phishing.difficulty.hard.text,
    fontSize: 11,
    fontWeight: 600,
    height: 22,
    '& .MuiChip-icon': {
      color: theme.palette.phishing.difficulty.hard.text,
    },
  },
  clickSubtitle: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  difficultyChip: {
    fontSize: 11,
    height: 22,
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: 'transparent',
  },
}))

export default useStyles
